import React from 'react';
import { makeStyles } from "@material-ui/core";
import { dimensionQualityChecks, uomKg } from '../../../Config/constants';

export default function ToleranceIndicator(props) {
    const classes = useStyles();

    let negWarningNumber = 0;
    let posWarningNumber = 0;
    let negErrorNumber = 0;
    let posErrorNumber = 0;
    let negTolerance = 0;
    let posTolerance = 0;
    let outNegToleranceWidth = 25;
    let inNegToleranceWidth = 25;
    let outPosToleranceWidth = 25;
    let inPosToleranceWidth = 25;
    let negWarnToleranceWidth = 0;
    let posWarnToleranceWidth = 0;
    let expectedValue = 0;

    const roundValues = (value) => {
        if (props.name) {
            if (props.name.includes('Weight')) {
                return parseInt(value);
            }
            else if (props.name.includes('Length')) {
                return Math.round(value);
            }
            else if (props.name.includes('Width')) {
                return parseInt(value);
            }
            else if (props.name.includes('Thickness')) {
                return value.toFixed(1);
            }
        }
        else {
            switch (props.qualityCheck.description) {
                case dimensionQualityChecks.LENGTEL:
                    return parseInt(value);
                case dimensionQualityChecks.LENGTER:
                    return parseInt(value);
                case dimensionQualityChecks.BREEDTE:
                    return parseInt(value);
                case dimensionQualityChecks.DIKTE:
                    return value.toFixed(1);
                case dimensionQualityChecks.GEWICHT:
                    return parseInt(value);
                default:
                    return value;
            }
        }
    }

    if (props.name) {
        if (props.name.includes('Weight')) {
            expectedValue = props.metaData[0].MassDensity.Value;
            negTolerance = - parseFloat(props.metaData[0].MassDensity.MinTolerance);
            posTolerance = parseFloat(props.metaData[0].MassDensity.MaxTolerance);
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].MassDensity.Value)) * props.toleranceFactor;
            outNegToleranceWidth = 100 - inNegToleranceWidth;
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].MassDensity.Value)) * props.toleranceFactor;
            outPosToleranceWidth = 100 - inPosToleranceWidth;
        } else if (props.name.includes('Length')) {
            expectedValue = props.metaData[0].Length.Value;
            if (props.metaDataVersion === 2) {
                expectedValue = props.metaData[0].SettingLength.Value;
            }
            negTolerance = - parseFloat(props.metaData[0].Length.MinTolerance);
            posTolerance = parseFloat(props.metaData[0].Length.MaxTolerance);
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(expectedValue)) * props.toleranceFactor;
            outNegToleranceWidth = 100 - inNegToleranceWidth;
            inPosToleranceWidth = (posTolerance / parseFloat(expectedValue)) * props.toleranceFactor;
            outPosToleranceWidth = 100 - inPosToleranceWidth;
        } else if (props.name.includes('Width')) {
            expectedValue = props.metaData[0].Width.Value;
            negTolerance = - parseFloat(props.metaData[0].Width.MinTolerance);
            posTolerance = parseFloat(props.metaData[0].Width.MaxTolerance);
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].Width.Value)) * props.toleranceFactor;
            outNegToleranceWidth = 100 - inNegToleranceWidth;
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].Width.Value)) * props.toleranceFactor;
            outPosToleranceWidth = 100 - inPosToleranceWidth;
        } else if (props.name.includes('Thickness')) {
            expectedValue = props.metaData[0].Thickness.Value;
            negTolerance = - parseFloat(props.metaData[0].Thickness.MinTolerance);
            posTolerance = parseFloat(props.metaData[0].Thickness.MaxTolerance);
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].Thickness.Value)) * props.toleranceFactor;
            outNegToleranceWidth = 100 - inNegToleranceWidth;
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].Thickness.Value)) * props.toleranceFactor;
            outPosToleranceWidth = 100 - inPosToleranceWidth;
        }

        posErrorNumber = posTolerance;
        negErrorNumber = negTolerance;

    } else if (props.qualityCheck) {


        // if (props.qualityCheck.toleranceWarningMin) {
        //     negWarnTolerance = - parseFloat(props.qualityCheck.toleranceWarningMin)
        // }
        // if (props.qualityCheck.toleranceWarningMax) {
        //     posWarnTolerance = parseFloat(props.qualityCheck.toleranceWarningMax)
        // }

        posErrorNumber = (props.qualityCheck.toleranceErrorMax);
        negErrorNumber = (props.qualityCheck.toleranceErrorMin);

        // negTolerance = - parseFloat(props.qualityCheck.toleranceErrorMin) - negWarnTolerance
        // posTolerance = parseFloat(props.qualityCheck.toleranceErrorMax) - posWarnTolerance

        // console.log("factor")
        // console.log(props.toleranceFactor)
        // console.log("negTolerance")
        // console.log(negTolerance)


        expectedValue = props.qualityCheck.expectedValue;
        negWarningNumber = props.qualityCheck.toleranceWarningMin;
        posWarningNumber = props.qualityCheck.toleranceWarningMax;

        if (negWarningNumber === null || negWarningNumber === undefined) {
            negWarningNumber = 0;
        }
        if (posWarningNumber === null || posWarningNumber === undefined) {
            posWarningNumber = 0;
        }
        if (negErrorNumber === null || negErrorNumber === undefined) {
            negErrorNumber = 0;
        }
        if (posErrorNumber === null || posErrorNumber === undefined) {
            posErrorNumber = 0;
        }

        if (negErrorNumber > posErrorNumber) {
            outNegToleranceWidth = 20;
            outPosToleranceWidth = 100 - (0.8 * (posErrorNumber / negErrorNumber) * 100);
        } else if (negErrorNumber === posErrorNumber) {
            outPosToleranceWidth = 20;
            outNegToleranceWidth = 20;
        } else {
            outPosToleranceWidth = 20;
            if (posErrorNumber === 0) {
                outNegToleranceWidth = 80;
            }
            else {
                outNegToleranceWidth = 100 - (0.8 * (negErrorNumber / posErrorNumber) * 100);
            }
        }

        if (props.qualityCheck.toleranceWarningMin && props.qualityCheck.toleranceWarningMax) {
            negWarnToleranceWidth = (props.qualityCheck.toleranceWarningMin / negErrorNumber) * (100 - outNegToleranceWidth);
            posWarnToleranceWidth = (props.qualityCheck.toleranceWarningMax / posErrorNumber) * (100 - outPosToleranceWidth);
        }

        inNegToleranceWidth = 100 - negWarnToleranceWidth - outNegToleranceWidth;
        inPosToleranceWidth = 100 - posWarnToleranceWidth - outPosToleranceWidth;

        if (props.qualityCheck.uom === uomKg) {
            expectedValue = expectedValue * 1000;
            negWarningNumber = negWarningNumber * 1000;
            posWarningNumber = posWarningNumber * 1000;
            negErrorNumber = negErrorNumber * 1000;
            posErrorNumber = posErrorNumber * 1000;
        }
    }

    let negTolBorderRadius = "";
    let posTolBorderRadius = "";
    if (inNegToleranceWidth > 100) {
        negTolBorderRadius = "8px 0 0 8px";
        inNegToleranceWidth = 100;
    }
    if (inPosToleranceWidth > 100) {
        inPosToleranceWidth = 100;
        posTolBorderRadius = "0 8px 8px 0";
    }
    if (outPosToleranceWidth > 100) {
        outPosToleranceWidth = 100;
    }
    if (outNegToleranceWidth > 100) {
        outNegToleranceWidth = 100;
    }

    return <React.Fragment>
        {props.qualityCheck ?
            <React.Fragment>
                <div className={classes.container} style={{ height: "16px" }}>
                    <div className={classes.negToleranceNumber}></div>
                    <div className={classes.negTolerance}>
                        <div style={{ width: outNegToleranceWidth + "%" }}></div>
                        <div style={{ width: negWarnToleranceWidth === 0 ? negWarnToleranceWidth + "%" : inNegToleranceWidth + "%" }}></div>
                        {negWarnToleranceWidth !== 0 && <div className={classes.number}>{expectedValue - negWarningNumber}</div>}
                        <div style={{ width: negWarnToleranceWidth === 0 ? inNegToleranceWidth + "%" : negWarnToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.verticalToleranceSplitter} style={{ backgroundColor: "rgb(1,1,1,0)" }}></div>
                    <div className={classes.posTolerance}>
                        <div style={{ width: posWarnToleranceWidth === 0 ? inPosToleranceWidth + "%" : posWarnToleranceWidth + "%" }}></div>
                        {posWarnToleranceWidth !== 0 && <div className={classes.number}>{expectedValue + posWarningNumber}</div>}
                        <div style={{ width: posWarnToleranceWidth === 0 ? posWarnToleranceWidth + "%" : inPosToleranceWidth + "%" }}></div>
                        <div style={{ width: outPosToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.posToleranceNumber}></div>
                </div>
                <div className={classes.container} style={{ height: "8px" }}>
                    <div className={classes.negToleranceNumber}></div>
                    <div className={classes.negTolerance}>
                        <div style={{ width: outNegToleranceWidth + "%" }}></div>
                        <div style={{ width: negWarnToleranceWidth === 0 ? negWarnToleranceWidth + "%" : inNegToleranceWidth + "%" }}></div>
                        {negWarnToleranceWidth !== 0 && <div className={classes.verticalToleranceSplitter} style={{ backgroundColor: "gray", height: "8px" }}></div>}
                        <div style={{ width: negWarnToleranceWidth === 0 ? inNegToleranceWidth + "%" : negWarnToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.verticalToleranceSplitter} style={{ backgroundColor: "rgb(1,1,1,0)" }}></div>
                    <div className={classes.posTolerance}>
                        <div style={{ width: posWarnToleranceWidth === 0 ? inPosToleranceWidth + "%" : posWarnToleranceWidth + "%" }}></div>
                        {posWarnToleranceWidth !== 0 && <div className={classes.verticalToleranceSplitter} style={{ backgroundColor: "gray", height: "8px" }}></div>}
                        <div style={{ width: posWarnToleranceWidth === 0 ? posWarnToleranceWidth + "%" : inPosToleranceWidth + "%" }}></div>
                        <div style={{ width: outPosToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.posToleranceNumber}></div>
                </div>
                <div className={classes.container}>
                    <div className={classes.negToleranceNumber}></div>
                    <div className={classes.negTolerance}>
                        <div className={classes.outTolerance} style={{ width: outNegToleranceWidth + "%", borderRadius: "8px 0 0 8px" }}></div>
                        <div className={classes.warnTolerance} style={{ width: negWarnToleranceWidth === 0 ? negWarnToleranceWidth + "%" : inNegToleranceWidth + "%" }}></div>
                        <div className={classes.inTolerance} style={{ width: negWarnToleranceWidth === 0 ? inNegToleranceWidth + "%" : negWarnToleranceWidth + "%", borderRadius: negTolBorderRadius }}></div>
                    </div>
                    <div className={classes.verticalToleranceSplitter}></div>
                    <div className={classes.posTolerance}>
                        <div className={classes.inTolerance} style={{ width: posWarnToleranceWidth === 0 ? inPosToleranceWidth + "%" : posWarnToleranceWidth + "%", borderRadius: posTolBorderRadius }}></div>
                        <div className={classes.warnTolerance} style={{ width: posWarnToleranceWidth === 0 ? posWarnToleranceWidth + "%" : inPosToleranceWidth + "%" }}></div>
                        <div className={classes.outTolerance} style={{ width: outPosToleranceWidth + "%", borderRadius: "0 8px 8px 0" }}></div>
                    </div>
                    <div className={classes.posToleranceNumber}></div>
                </div>
                <div className={classes.container} style={{ height: "8px" }}>
                    <div className={classes.negToleranceNumber}></div>
                    <div className={classes.negTolerance}>
                        <div style={{ width: outNegToleranceWidth + "%" }}></div>
                        <div className={classes.verticalToleranceSplitter} style={{ backgroundColor: "gray", height: "8px" }}></div>
                        <div style={{ width: negWarnToleranceWidth === 0 ? negWarnToleranceWidth + "%" : inNegToleranceWidth + "%" }}></div>
                        <div style={{ width: negWarnToleranceWidth === 0 ? inNegToleranceWidth + "%" : negWarnToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.middleVerticalToleranceSplitter} style={{ backgroundColor: "gray", height: "16px" }}></div>
                    <div className={classes.posTolerance}>
                        <div style={{ width: posWarnToleranceWidth === 0 ? inPosToleranceWidth + "%" : posWarnToleranceWidth + "%" }}></div>
                        <div style={{ width: posWarnToleranceWidth === 0 ? posWarnToleranceWidth + "%" : inPosToleranceWidth + "%" }}></div>
                        <div className={classes.verticalToleranceSplitter} style={{ backgroundColor: "gray", height: "8px" }}></div>
                        <div style={{ width: outPosToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.posToleranceNumber}></div>
                </div>
                <div className={classes.container} style={{  }}>
                    <div className={classes.negToleranceNumber}></div>
                    <div className={classes.negTolerance}>
                        <div style={{ width: outNegToleranceWidth + "%" }}></div>
                        <div className={classes.number}>{expectedValue - negErrorNumber}</div>
                        <div style={{ width: negWarnToleranceWidth === 0 ? negWarnToleranceWidth + "%" : inNegToleranceWidth + "%" }}></div>
                        <div style={{ width: negWarnToleranceWidth === 0 ? inNegToleranceWidth + "%" : negWarnToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.middleNumber}>{expectedValue}</div>
                    <div className={classes.posTolerance}>
                        <div style={{ width: posWarnToleranceWidth === 0 ? inPosToleranceWidth + "%" : posWarnToleranceWidth + "%" }}></div>
                        <div style={{ width: posWarnToleranceWidth === 0 ? posWarnToleranceWidth + "%" : inPosToleranceWidth + "%" }}></div>
                        <div className={classes.number}>{expectedValue + posErrorNumber}</div>
                        <div style={{ width: outPosToleranceWidth + "%" }}></div>
                    </div>
                    <div className={classes.posToleranceNumber}></div>
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <div className={classes.container}>
                    <div className={classes.negToleranceNumber} style={{ height: "8px" }}>{roundValues(expectedValue + negErrorNumber)}</div>
                    <div className={classes.negTolerance} style={{ height: "8px", paddingTop: "5px" }}>
                        <div className={classes.outTolerance} style={{ width: outNegToleranceWidth + "%", borderRadius: "8px 0 0 8px", height: "8px" }}></div>
                        <div className={classes.inTolerance} style={{ width: inNegToleranceWidth + "%", borderRadius: negTolBorderRadius, height: "8px" }}></div>
                    </div>
                    <div className={classes.verticalToleranceSplitter} style={{ height: "8px" }}></div>
                    <div className={classes.posTolerance} style={{ height: "8px", paddingTop: "5px" }}>
                        <div className={classes.inTolerance} style={{ width: inPosToleranceWidth + "%", borderRadius: posTolBorderRadius, height: "8px" }}></div>
                        <div className={classes.outTolerance} style={{ width: outPosToleranceWidth + "%", borderRadius: "0 8px 8px 0", height: "8px" }}></div>
                    </div>
                    <div className={classes.posToleranceNumber} style={{ height: "8px" }}>{roundValues(expectedValue + posErrorNumber)}</div>
                </div>
            </React.Fragment>
        }
    </React.Fragment>
}

const useStyles = makeStyles({
    posTolerance: {
        width: "calc(35% - 1px)",
        display: "flex",
        flexDirection: "row"
    },
    negTolerance: {
        width: "calc(35% - 1px)",
        display: "flex",
        flexDirection: "row"
    },
    verticalToleranceSplitter: {
        width: "2px",
        backgroundColor: "white",
        height: "16px"
    },
    middleVerticalToleranceSplitter: {
        width: "2px",
        backgroundColor: "white",
        height: "16px"
    },
    inTolerance: {
        backgroundColor: "#5CC958",
        height: "16px",
    },
    warnTolerance: {
        height: "16px",
        backgroundImage: "repeating-linear-gradient(-45deg, #FFA500, #FFA500 5px, white 5px, white 10px);"
    },
    outTolerance: {
        backgroundColor: "#ea9999",
        height: "16px",
    },
    posToleranceNumber: {
        width: "12%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: '300 !important',
        color: "#020100",
        paddingLeft: "10px",
        textAlign: "left"
    },
    negToleranceNumber: {
        width: "12%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: '300 !important',
        color: "#020100",
        paddingRight: "10px",
        textAlign: "right"
    },
    container: {
        display: "flex",
        flexDirection: "row",
    },
    number: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: '300 !important',
        color: "#020100",
    },
    middleNumber:{
        paddingTop: '10px',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: '300 !important',
        color: "#020100",
    }
});